export default "__VITE_ASSET__CKYMuUxX__"